import * as _ from 'lodash';
import { useEffect } from 'react';

/**
 * Replacement for class-based componentDidMount lifecycle hook.
 * Allows you to invoke a function when the component is mounted.
 * Note: the function can be async.
 *
 * @param {() => void} onMount - Function to be invoked when the component mounts.
 * @param {() => void} onUnmount - Function to be invoked when the component unmounts.
 */
const useOnMount = (
  onMount: () => void,
  onUnmount: () => void = _.noop,
) => {
  useEffect(() => {
    onMount();
    return onUnmount;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useOnMount;
